<template>
  <div class="businessStoreRelation">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.bsSubjectName" placeholder="商户名称" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.bsPhone" placeholder="商户电话" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.csName" placeholder="代理名称" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.csPhone" placeholder="代理电话" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="selectBs()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
          <el-button style="background-color:#F7FE2E" icon="el-icon-plus" @click="addBs()">添加商户</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data" style="margin:auto;width:calc(100% - 30px)" height="716" border  :header-cell-style="{background:'#01DFD7',color:'#fff'}"
                v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0.8, 0, 0, 0.3)"
                :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }">
        <el-table-column label="商户编号" width="150" align="center" prop="bsCode"></el-table-column>
        <el-table-column label="商户类型" width="150" align="center" prop="bsType"></el-table-column>
        <el-table-column label="主体名称" width="150" align="center" prop="bsName"></el-table-column>
        <el-table-column label="所属代理" width="200" align="center" prop="csName"></el-table-column>
        <el-table-column label="代理电话" width="200" align="center" prop="csPhone"></el-table-column>
        <el-table-column label="联系方式" width="150" align="center" prop="bsPhone"></el-table-column>
        <el-table-column label="所在地区" width="200" align="center" prop="area"></el-table-column>
        <el-table-column label="详细地址" width="350" align="center" prop="address"></el-table-column>
        <el-table-column label="可见账单" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.billFlag === '1'">可见</el-tag>
            <el-tag type="success" v-else>不可见</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否分润" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.rewardFlag === '1'">已开通</el-tag>
            <el-tag type="success" v-else>未开通</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分润比例" width="100" align="center">
          <template slot-scope="scope">
            <span type="success" v-if="scope.row.rewardPercent != null">{{scope.row.rewardPercent}}</span>
            <span type="success" v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.delFlag === '0'">正常</el-tag>
            <el-tag type="danger" v-else>冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center"  fixed="right">
         <template slot-scope="scope">
            <el-button type="warning" size="small" plain @click="bsDetail(scope.row.id)">门店</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <add-bs v-if="addBsDialog" ref="addBs" @add-succeed="addSucceed"></add-bs>
    <bs-detail v-if="bsDetailDialog" ref="bsDetail"></bs-detail>
  </div>
</template>

<script>
import { getAllBsList, operationAccount} from "../../api/relation/businessstorerelation.js";
import AddBs from './addBs.vue'
import BsDetail from './bsDetail.vue'
export default {
  components: { AddBs,BsDetail },
  name: "BsRelation",
  data() {
    return {
      request: {
        bsSubjectName: '',
        bsPhone: '',
        csName: '',
        csPhone: '',
        current: '',
        size: ''
      },
      response: {data: [], total: 0},
      query: {current: 1, size: 15},
      loading: false,
      addBsDialog: false,
      bsDetailDialog: false,
      id: "",
      subjectName: "",
      phone: "",
      total: "",
      current: "1",
      boxMessage: "",
      boxTitle: "",
      bsList: "",
      table: false,
      activeName: "first",
      bsId: "",
      accountOperation: 0,
      titleImg: require("../../../static/image/relation/daili-dlxq.png"),
      bsStoreInfo: ""
    };
  },
  methods: {

    /**
     * 查询商户列表
     */
    selectBs() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllBsList(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.selectBs()
    },

    /**
     * 重置
     */
    reset(){
      this.request.bsSubjectName = "";
      this.request.bsPhone = "";
      this.request.csName = "";
      this.request.csPhone = "";
      this.request.current = 1;
      this.request.size = 10;
      this.query.current = 1;
      this.query.size = 10;
      this.selectBs();
    },

    /**
     * 添加商户
     */
    addBs(){
      this.addBsDialog = true;
      this.$nextTick(() =>{
        this.$refs.addBs.init();
      })
    },

    /**
     * 监听子组件
     */
    addSucceed(value){
      this.selectBs();
    },

    /**
     * 商户详情
     */
    bsDetail(id){
      this.bsDetailDialog = true;
      this.$nextTick(() =>{
        this.$refs.bsDetail.init(id);
      })
    },

    /**
     * 账号操作
     */
    operationAccount(id,state){
      operationAccount({identity: "bs",id: id,state: state === "0" ? "1" : "0"}).then(result=>{
        this.$confirm('操作成功', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success',
          center: true
        }).then(() => {
          this.selectBs();
          })
      })
    }
  },
  created() {
    this.selectBs();
  }
};
</script>
<style scoped>
.businessStoreRelation {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/relation/businessstorerelation.vue